<template>
  <el-dialog
    title="提示" :visible.sync="visible" @close="handleClose"
    width="600px">
    <el-form
      class="form"
      :model="form"
      :rules="rules"
      ref="form"
      label-width="120px">
      <el-form-item label="作废原因" prop="remark">
        <el-row>
          <el-col :span="20">
            <el-input class="input-width" v-model="form.remark" placeholder="请输入不超过50个字" maxlength="50"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <div>作废后不可恢复，是否确定进行作废</div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button  @click="handleClose">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'invalidDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object
    }
  },
  data () {
    return {
      visible: this.show,
      form: {
        remark: ''
      },
      rules: {
        remark: [
          { required: true, message: '请填写作废原因' }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['invalidInstantDiscountUseRule']),
    handleSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const { id } = this.formData
          const { remark } = this.form
          const submitObj = {
            id,
            remark,
            status: 3
          }
          this.invalidInstantDiscountUseRule({ ...submitObj }).then(res => {
            this.$parent.handleSearch()
            this.handleClose()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          })
        } else {
          return false
        }
      })
    },
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.form.remark = ''
      this.visible = newVal
      if (newVal) {
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin: 0 auto;
}

.form-input, .form-select, .el-input-number, .input-width {
  width: 200px;
}
</style>
